import _ from 'underscore';
import { originalActionTextMapper, newActionTextMapper } from '@bingads-webui-campaign-legacy/adextension-actionlink/model/language-type-translator';
import config from '@bingads-webui-component-legacy/config/index';
import { globalizationModelSetup } from '@bingads-webui-campaign/ads-globalization';

const BoostSupportedLanguages = [
  'Arabic',
  'Catalan',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Finnish',
  'French',
  'Gaelic',
  'German',
  'Greek',
  'Hebrew',
  'Hindi',
  'Hungarian',
  'Indonesian',
  'Italian',
  'Japanese',
  'Korean',
  'Norwegian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'SimplifiedChinese',
  'Slovak',
  'Spanish',
  'Swedish',
  'Thai',
  'TraditionalChinese',
  'Turkish',
  'Ukrainian',
  'Vietnamese',
  'Afrikaans',
  'Albanian',
  'Amharic',
  'Armenian',
  'Assamese',
  'Azerbaijani',
  'Basque',
  'Bengali',
  'Cambodian',
  'Estonian',
  'Galician',
  'Georgian',
  'Gujarati',
  'Kannada',
  'Kazakh',
  'Laotian',
  'Malay',
  'Malayalam',
  'Maori',
  'Marathi',
  'Nepali',
  'Oriya',
  'Persian',
  'Punjabi',
  'Quechua',
  'Tamil',
  'Telugu',
  'Urdu',
  'Uzbek',
  'Welsh',
  'Bulgarian',
  'Bosnian',
  'Croatian',
  'Icelandic',
  'Lithuanian',
  'Latvian',
  'Macedonian',
  'Maltese',
  'Slovenian',
  'Tagalog',
];

const permissions = config.get('permissions');

const pickLanguages = (languages, languageMap, newHeadersMap) =>
  _.object(_.chain(languages)
    // eslint-disable-next-line
    .reduce((memo, languages) => {
      const outMemo = memo;

      let current =  languageMap[languages];

      if (permissions && permissions.IsNewActionAdextensionHeadersEnabled) {
        current = Object.assign(current, newHeadersMap[languages]);
      }
      outMemo[languages] = current;
      return outMemo;
    }, {})
    .pairs()
    .value());

let {
  LANGUAGES: enabledLanguageList,
} = globalizationModelSetup({
  permissions,
  culture: config.get('culture'),
});

// Only for Boost(Amplify enabled account), we support more languages for CTA
if (permissions && permissions.IsAmplifyEnabled) {
  enabledLanguageList = _.union(enabledLanguageList, BoostSupportedLanguages);

  enabledLanguageList.sort();
}

const actionTextMapper = pickLanguages(enabledLanguageList, originalActionTextMapper, newActionTextMapper);

const actionTypeMapper = { // may remove some action type
  Browse: 'LearnMore',
  VisitSite: 'LearnMore',
  ViewNow: 'LearnMore',
  Explore: 'LearnMore',
  SeeMore: 'LearnMore',
  StartFree: 'FreeTrial',
  NewCars: 'ViewCars',
  UsedCars: 'ViewCars',
  Message: 'ContactUs',
};

export function mapActionType(actionType) { // mapper action type and
  return _.result(actionTypeMapper, actionType, actionType);
}

export function getActionText(item) {
  if (_.isUndefined(item)) {
    return '';
  }
  const { Language, ActionType } = item;

  const actionType = mapActionType(ActionType);

  return _.chain(actionTextMapper).result(Language).result(actionType).value(); // will fallback to default if mapped action type not exist
}

export function getActionType(item) {
  if (_.isUndefined(item)) {
    return '';
  }
  const { Language, text } = item;

  return _.chain(actionTextMapper).result(Language).invert().result(text).value();
}

export function getActionTypeTextMapper(item) {
  if (_.isUndefined(item)) {
    return {};
  }
  const { Language, reserveActionType } = item;
  const actionType = mapActionType(reserveActionType);
  let mapper = _.omit(actionTextMapper[Language] || {}, _.keys(actionTypeMapper)); // omit mapped action type

  if (permissions && permissions.IsDomesticSimplifiedChineseEnabled) {
    mapper = _.omit(mapper || {}, _.keys({
      BetNow: 'BetNow',
      Donate: 'Donate'})); // omit betNow and Donate for china market pilot account
  }

  const reserveValue = mapper[actionType];
  const ret = _.invert(_.extend({}, mapper));

  ret[reserveValue] = actionType;

  return _.invert(ret);
}

export function getLanguages() {
  return _.keys(actionTextMapper);
}

export function getDefaultActionType(item) {
  if (_.isUndefined(item)) {
    return '';
  }
  const { Language } = item;

  const actionType = _.chain(actionTextMapper)
    .result(Language)
    .keys()
    .sortBy()
    .first()
    .value();

  return mapActionType(actionType);
}
